import { useEffect, useState } from 'react';
import { api } from '../api';

const emptyForm = {
  area_name: '',
  area_slug: '',
  page_path: '',
  area_content: '',
  types: [{ type_key: '', type_value: '' }],
  sections: [{ section_title: '', itemsText: '' }],
};

const toForm = (area) => ({
  ...area,
  types: area.types?.length ? area.types : emptyForm.types,
  sections: (area.sections || []).map((section) => ({
    section_title: section.section_title,
    itemsText: (section.items || []).map((item) => item.item_content).join('\n'),
  })),
});

const toPayload = (form) => ({
  ...form,
  types: form.types.filter((type) => type.type_value),
  sections: form.sections
    .filter((section) => section.section_title)
    .map((section) => ({
      section_title: section.section_title,
      items: section.itemsText.split('\n').map((line) => line.trim()).filter(Boolean),
    })),
});

export default function AreaPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [originalSlug, setOriginalSlug] = useState('');
  const [isNew, setIsNew] = useState(true);

  const load = () => api.areas.list().then(setItems).catch((error) => alert(error.message));
  useEffect(() => { load(); }, []);

  const submit = (event) => {
    event.preventDefault();
    api.areas.save(originalSlug || form.area_slug, toPayload(form), isNew)
      .then(() => { setForm(emptyForm); setIsNew(true); setOriginalSlug(''); load(); })
      .catch((error) => alert(error.response?.data?.message || error.message));
  };

  return (
    <>
      <h2>사업영역</h2>
      <form onSubmit={submit}>
        <input placeholder="이름" value={form.area_name} onChange={(e) => setForm({ ...form, area_name: e.target.value })} required />
        <input placeholder="slug (system-develop)" value={form.area_slug} onChange={(e) => setForm({ ...form, area_slug: e.target.value })} required />
        <input placeholder="page_path (/business/SystemDevelop)" value={form.page_path} onChange={(e) => setForm({ ...form, page_path: e.target.value })} required />
        <textarea placeholder="설명" value={form.area_content || ''} onChange={(e) => setForm({ ...form, area_content: e.target.value })} />
        <h4>유형</h4>
        {form.types.map((type, index) => (
          <div className="row" key={index}>
            <input placeholder="key" value={type.type_key} onChange={(e) => {
              const types = [...form.types];
              types[index] = { ...type, type_key: e.target.value };
              setForm({ ...form, types });
            }} />
            <input placeholder="value" value={type.type_value} onChange={(e) => {
              const types = [...form.types];
              types[index] = { ...type, type_value: e.target.value };
              setForm({ ...form, types });
            }} />
          </div>
        ))}
        <button type="button" className="ghost" onClick={() => setForm({ ...form, types: [...form.types, { type_key: '', type_value: '' }] })}>유형 추가</button>
        <h4>섹션 (항목은 줄바꿈)</h4>
        {form.sections.map((section, index) => (
          <div className="card" key={index}>
            <input placeholder="섹션 제목" value={section.section_title} onChange={(e) => {
              const sections = [...form.sections];
              sections[index] = { ...section, section_title: e.target.value };
              setForm({ ...form, sections });
            }} />
            <textarea placeholder={'항목1\n항목2'} value={section.itemsText} onChange={(e) => {
              const sections = [...form.sections];
              sections[index] = { ...section, itemsText: e.target.value };
              setForm({ ...form, sections });
            }} />
          </div>
        ))}
        <button type="button" className="ghost" onClick={() => setForm({ ...form, sections: [...form.sections, { section_title: '', itemsText: '' }] })}>섹션 추가</button>
        <div className="row">
          <button type="submit">{isNew ? '추가' : '수정'}</button>
          <button type="button" className="ghost" onClick={() => { setForm(emptyForm); setIsNew(true); setOriginalSlug(''); }}>취소</button>
        </div>
      </form>
      {items.map((item) => (
        <div className="card" key={item.area_id}>
          <strong>{item.area_name}</strong> ({item.area_slug})
          <p>{item.area_content}</p>
          <div className="row">
            <button type="button" onClick={() => { setForm(toForm(item)); setIsNew(false); setOriginalSlug(item.area_slug); }}>수정</button>
            <button type="button" className="danger" onClick={() => window.confirm('삭제할까요?') && api.areas.remove(item.area_slug).then(load)}>삭제</button>
          </div>
        </div>
      ))}
    </>
  );
}
